import React from "react";
import Reveal from "./Reveal";
import { useLang } from "../lib/lang-context";
import { SealCheck } from "@phosphor-icons/react";

export default function Certifications() {
  const { t } = useLang();
  return (
    <section
      id="certifications"
      data-testid="certifications-section"
      className="py-24 md:py-32 bg-white dark:bg-zinc-950 border-t border-slate-200 dark:border-zinc-800"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <Reveal className="lg:col-span-7">
            <p className="text-xs tracking-[0.24em] uppercase font-bold text-[var(--icor-blue)] eyebrow-line">
              {t.certifications.eyebrow}
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tighter mt-5 text-[var(--icor-navy)] dark:text-white text-balance">
              {t.certifications.title}
            </h2>
          </Reveal>
          <Reveal delay={120} className="lg:col-span-5">
            <p className="text-base text-slate-600 dark:text-zinc-400 leading-relaxed">
              {t.certifications.subtitle}
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 dark:bg-zinc-800 border border-slate-200 dark:border-zinc-800">
          {t.certifications.items.map((item, i) => (
            <Reveal
              key={i}
              delay={i * 110}
              data-testid={`cert-card-${i}`}
              className="bg-white dark:bg-zinc-950 p-8 group hover:bg-slate-50 dark:hover:bg-zinc-900 transition-colors"
            >
              <div
                className="w-12 h-12 flex items-center justify-center mb-5"
                style={{
                  background: "rgba(0,82,255,0.08)",
                  color: "var(--icor-blue)",
                  borderRadius: 4,
                }}
              >
                <SealCheck size={26} weight="duotone" />
              </div>
              <div className="font-display text-2xl font-bold tracking-tighter text-[var(--icor-navy)] dark:text-white">
                {item.name}
              </div>
              <p className="mt-3 text-sm text-slate-600 dark:text-zinc-400 leading-relaxed">
                {item.desc}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
